import man from '../../../../shared/img/ppt/man_final.png';
import woman from '../../../../shared/img/ppt/woman_final.png';
import logo from '../../../../shared/img/logo/logo_MW.png';

const addSlide8 = (pptx, addBrandingToSlide) => {
  // presentation slide
  const slide8 = pptx.addSlide({ masterName: 'COMPANY_BRANDING' });
  slide8.addText(
    [
      { text: 'A BIENTOT SUR NOTRE', options: { bold: true, color: '696969' } },
      { text: '\nPLATEFORME', options: { bold: true, color: '696969' } },
    ],
    {
      x: 1,
      y: 0.2,
      w: 8,
      h: 1,
      align: 'center',
      fontSize: 24,
    },
  );

  slide8.addImage({
    path: woman,
    x: 0.5,
    y: 1,
    w: 1,
    h: 4,
  });
  slide8.addImage({
    path: man,
    x: 8,
    y: 1,
    w: 1.5,
    h: 4,
  });
  slide8.addShape(pptx.ShapeType.ellipse, {
    x: 3.4,
    y: 1.7,
    w: 3.1,
    h: 3.1, // w = h -> cercle
    fill: { color: 'FFFFFF' },
    line: { color: 'FFFFFF' }, // pas de bordure visible
  });

  // add logo
  slide8.addImage({
    path: logo,
    x: 3.6,
    y: 2.3,
    w: 3,
    h: 1.7,
  });

  addBrandingToSlide(pptx, slide8);
};

export default addSlide8;
